import { useState } from "react";
import loadRecruitics from "~/utils/tracking/load_recruitics";

const useRecruitics = (enableRecruitics: boolean, internal = false) => {
  const [recruitics, setRecruitics] = useState(false);

  if (!recruitics && !internal) {
    void loadRecruitics(enableRecruitics);
    setRecruitics(true);
  }
};

export default useRecruitics;
